import { isBrowser } from '../../../utils/conditions';

// 다이알로그를 노출합니다
// https://www.notion.so/croquis/WEB-42ca24a272c643c4ad8fd093e758de8f
type DialogType = 'complete' | 'warning';
type DialogMessage =
  | string
  | {
      title?: string;
      message: string;
      ok?: string;
      cancel?: string;
      type?: DialogType;
    };
const getDialogMessage = (message: DialogMessage) => {
  if (typeof message === 'string') {
    return message;
  } else {
    return JSON.stringify(message);
  }
};

export const Dialog = {
  alert: (message: DialogMessage) => {
    if (isBrowser()) {
      window.alert(getDialogMessage(message));
    }
  },
  confirm: (message: DialogMessage) => {
    if (isBrowser()) {
      return window.confirm(getDialogMessage(message));
    }
    return true;
  },
};
